module.exports = __webpack_public_path__ + "img/TSimple.ef9decab.png";